import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermosPoliticasRoutingModule } from './termos-politicas-routing.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TermosPoliticasRoutingModule
  ]
})

export class TermosPoliticasModule { }
